(function () {
  if (customElements.get('spc-ship-estimate')) return;

  // Load the matching stylesheet from the same asset folder.
  var me = document.currentScript;
  if (me && me.src) {
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = me.src.replace('spc-shipping-estimate.js', 'spc-shipping-estimate.css');
    document.head.appendChild(link);
  }

  var STORE_KEY = 'spc_ship_zip';
  // Baseline ZIP quoted before a shopper enters their own. Change this one value to move the baseline.
  var DEFAULT_ZIP = '10001';
  // How long to wait after the last cart change before re-quoting carrier rates.
  var REFRESH_DEBOUNCE = 350;
  // Free-shipping threshold in cents. window.SPC_FREE_SHIP_MIN wins if Liquid sets it,
  // so this can be driven from settings.free_shipping_minimum_amount later without touching JS.
  var THRESHOLD = 7500;
  // US ZIP prefix (first 3 digits) ranges -> state code. Shopify needs the state to quote carrier rates.
  var RANGES = [
    [5,5,'NY'],[6,9,'PR'],[10,27,'MA'],[28,29,'RI'],[30,38,'NH'],[39,49,'ME'],[50,54,'VT'],[55,55,'MA'],[56,59,'VT'],
    [60,69,'CT'],[70,89,'NJ'],[90,99,'AE'],[100,149,'NY'],[150,196,'PA'],[197,199,'DE'],[200,200,'DC'],[201,201,'VA'],
    [202,205,'DC'],[206,219,'MD'],[220,246,'VA'],[247,268,'WV'],[270,289,'NC'],[290,299,'SC'],[300,319,'GA'],
    [320,339,'FL'],[340,340,'AA'],[341,349,'FL'],[350,369,'AL'],[370,385,'TN'],[386,397,'MS'],[398,399,'GA'],
    [400,427,'KY'],[430,459,'OH'],[460,479,'IN'],[480,499,'MI'],[500,528,'IA'],[530,549,'WI'],[550,567,'MN'],
    [569,569,'DC'],[570,577,'SD'],[580,588,'ND'],[590,599,'MT'],[600,629,'IL'],[630,658,'MO'],[660,679,'KS'],
    [680,693,'NE'],[700,714,'LA'],[716,729,'AR'],[730,732,'OK'],[733,733,'TX'],[734,749,'OK'],[750,799,'TX'],
    [800,816,'CO'],[820,831,'WY'],[832,838,'ID'],[840,847,'UT'],[850,865,'AZ'],[870,884,'NM'],[885,885,'TX'],
    [889,898,'NV'],[900,961,'CA'],[962,966,'AP'],[967,968,'HI'],[969,969,'GU'],[970,979,'OR'],[980,994,'WA'],
    [995,999,'AK']
  ];

  function stateFor(zip) {
    var p = parseInt(zip.slice(0, 3), 10);
    for (var i = 0; i < RANGES.length; i++) {
      if (p >= RANGES[i][0] && p <= RANGES[i][1]) return RANGES[i][2];
    }
    return null;
  }
  function money(n) { return '$' + Number(n).toFixed(2); }
  function readZip() { try { return localStorage.getItem(STORE_KEY) || ''; } catch (e) { return ''; } }
  function saveZip(z) { try { localStorage.setItem(STORE_KEY, z); } catch (e) {} }
  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  var inflight = null; // one quote at a time; the drawer and cart page can both be on screen
  var cache = {};      // zip|cart total -> rates, so reopening the drawer doesn't re-quote

  async function quote(zip, state) {
    var q = 'shipping_address[zip]=' + encodeURIComponent(zip) +
            '&shipping_address[country]=US&shipping_address[province]=' + state;
    var prep = await fetch('/cart/prepare_shipping_rates.json?' + q, { method: 'POST' });
    if (prep.status >= 400) {
      var err = {};
      try { err = await prep.json(); } catch (e) {}
      throw new Error((err.zip && err.zip[0]) || (err.error && err.error[0]) || 'We could not quote that ZIP code.');
    }
    for (var i = 0; i < 12; i++) {
      var res = await fetch('/cart/async_shipping_rates.json?' + q);
      if (res.status === 200) {
        var data = await res.json();
        if (data && data.shipping_rates) return data.shipping_rates;
      }
      await wait(700);
    }
    throw new Error('Shipping rates are taking a moment. Try again, or see them at checkout.');
  }

  var MARKUP =
    '<div class="spc-ship__row"><span class="spc-ship__label">Estimated shipping</span>' +
    '<span class="spc-ship__value" data-spc-value>Enter your ZIP</span></div>' +
    '<span class="spc-ship__bar" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0" aria-label="Progress toward free US shipping" data-spc-bar>' +
    '<span class="spc-ship__fill" data-spc-fill></span></span>' +
    '<div class="spc-ship__form">' +
    '<input class="spc-ship__input field__input" type="text" inputmode="numeric" maxlength="10" autocomplete="postal-code" placeholder="US ZIP code" aria-label="US ZIP code for a shipping estimate" data-spc-zip>' +
    '<button type="button" class="spc-ship__button button button--secondary" data-spc-go>Estimate</button></div>' +
    '<p class="spc-ship__note" data-spc-note></p>' +
    '<p class="spc-ship__nudge" data-spc-nudge hidden></p>';

  class SpcShipEstimate extends HTMLElement {
    async connectedCallback() {
      // A node that survived a section re-render is already built — just re-sync it to the cart.
      if (this.dataset.ready) { this.refresh(true); return; }
      this.dataset.ready = '1';
      this.innerHTML = MARKUP;
      this.classList.add('spc-ship');

      this.threshold = parseInt(this.dataset.threshold || window.SPC_FREE_SHIP_MIN || THRESHOLD, 10) || THRESHOLD;
      this.total = 0;
      this.seq = 0;
      this.cart = null;
      this.valueEl = this.querySelector('[data-spc-value]');
      this.noteEl = this.querySelector('[data-spc-note]');
      this.nudgeEl = this.querySelector('[data-spc-nudge]');
      this.barEl = this.querySelector('[data-spc-bar]');
      this.fillEl = this.querySelector('[data-spc-fill]');
      this.input = this.querySelector('[data-spc-zip]');
      this.btn = this.querySelector('[data-spc-go]');

      var self = this;
      this.btn.addEventListener('click', function () { self.run(self.input.value); });
      this.input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); self.run(self.input.value); }
      });

      this.reset();
      await this.refresh(true);
    }

    remainingCents() { return this.threshold - this.total; }

    // Re-read the cart and re-quote. Called on first mount and on every cart change.
    async refresh(force) {
      if (!this.valueEl) return; // not built yet
      var cart = null;
      try {
        cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); });
      } catch (e) { cart = null; }

      if (cart) {
        this.cart = cart;
        this.hidden = !cart.item_count;
        if (!cart.item_count) return;
        if (cart.total_price === this.total && !force) return;
        this.total = cart.total_price;
      }

      var zip = String(this.input.value || readZip() || DEFAULT_ZIP).trim().slice(0, 5);
      if (/^\d{5}$/.test(zip)) {
        this.input.value = zip;
        this.paintRemaining();   // instant: the bar and the "$X away" number move with the cart
        this.run(zip, true);     // then the carrier number catches up
      } else {
        this.reset();
      }
    }

    // ---- Progress bar -------------------------------------------------------
    paintBar() {
      if (!this.fillEl || !this.threshold) return;
      var pct = Math.round((this.total / this.threshold) * 100);
      if (!isFinite(pct) || pct < 0) pct = 0;
      if (pct > 100) pct = 100;
      this.fillEl.style.width = pct + '%';
      this.barEl.setAttribute('aria-valuenow', String(pct));
    }

    // ---- "One more herb" nudge ---------------------------------------------
    // Measured against the cheapest thing already in their basket, so the claim is
    // true for this shopper. Stays silent when the gap is wide — "about nine more
    // herbs" reads as a reason to give up, not a reason to add one.
    nudgeText() {
      var remaining = this.remainingCents();
      if (remaining <= 0 || !this.cart || !this.cart.items || !this.cart.items.length) return '';
      var unit = 0;
      this.cart.items.forEach(function (item) {
        var p = item.final_price || item.price || 0;
        if (p > 0 && (!unit || p < unit)) unit = p;
      });
      if (!unit) return '';
      var n = Math.ceil(remaining / unit);
      if (n === 1) return 'About one more herb gets you there.';
      if (n === 2) return 'About two more herbs and you’re there.';
      return '';
    }

    paintNudge() {
      if (!this.nudgeEl) return;
      var text = this.nudgeText();
      this.nudgeEl.textContent = text;
      this.nudgeEl.hidden = !text;
    }

    // Repaint the threshold sentence, bar and nudge for the new total without
    // collapsing back to the ZIP form.
    paintRemaining() {
      this.classList.toggle('is-free', this.remainingCents() <= 0);
      this.paintBar();
      this.paintNudge();
      if (!this.classList.contains('has-estimate')) { this.reset(); return; }
      var remaining = this.remainingCents();
      this.valueEl.textContent = 'Checking…';
      this.noteEl.textContent = remaining > 0
        ? 'You’re ' + money(remaining / 100) + ' away from free US shipping.'
        : 'You’ve unlocked free US shipping.';
    }

    async run(raw, silent) {
      var zip = String(raw || '').trim().slice(0, 5);
      this.classList.remove('is-error');
      if (!/^\d{5}$/.test(zip)) {
        if (!silent) this.fail('Enter a 5-digit US ZIP code. International shipping is calculated at checkout.');
        return;
      }
      var state = stateFor(zip);
      if (!state) { if (!silent) this.fail('We could not find that ZIP code.'); return; }

      var seq = ++this.seq; // an older quote must never paint over a newer one
      this.classList.add('is-loading');
      this.valueEl.textContent = 'Checking…';
      try {
        var key = zip + '|' + this.total;
        var rates = cache[key];
        if (!rates) {
          while (inflight) { try { await inflight; } catch (e) {} }
          rates = cache[key];
          if (!rates) {
            inflight = quote(zip, state);
            rates = await inflight;
            inflight = null;
            cache[key] = rates;
          }
        }
        if (seq !== this.seq) return;
        saveZip(zip);
        this.show(zip, rates);
      } catch (e) {
        inflight = null;
        if (seq !== this.seq) return;
        if (silent) { this.reset(); } else { this.fail(e.message); }
      } finally {
        if (seq === this.seq) this.classList.remove('is-loading');
      }
    }

    show(zip, rates) {
      var prices = rates.map(function (r) { return { name: r.name, price: parseFloat(r.price) }; })
                        .sort(function (a, b) { return a.price - b.price; });
      var cheapest = prices[0];
      var remaining = this.remainingCents();
      this.classList.add('has-estimate');

      if (!cheapest) { this.fail('No shipping options for that ZIP code.'); return; }

      // Drive the success styling off the real quote, not the threshold — AK, HI and
      // APO addresses can sit above $75 and still be charged.
      this.classList.toggle('is-free', cheapest.price === 0);
      this.paintBar();
      this.paintNudge();

      if (cheapest.price === 0) {
        this.valueEl.textContent = 'FREE';
        this.noteEl.innerHTML = 'Free Economy shipping to ' + zip + '. Faster options are shown at checkout. ';
      } else {
        this.valueEl.textContent = 'from ' + money(cheapest.price);
        var msg = cheapest.name + ' to ' + zip + '.';
        if (remaining > 0) {
          msg = 'You’re <strong>' + money(remaining / 100) + '</strong> away from free US shipping, and would save ' +
                money(cheapest.price) + '. ' + msg + ' ';
        } else {
          msg += ' ';
        }
        this.noteEl.innerHTML = msg;
      }
      var change = document.createElement('button');
      change.type = 'button';
      change.className = 'spc-ship__change';
      change.textContent = 'Change ZIP';
      var self = this;
      change.addEventListener('click', function () {
        self.classList.remove('has-estimate');
        self.input.focus();
      });
      this.noteEl.appendChild(change);
    }

    reset() {
      var remaining = this.remainingCents();
      this.classList.toggle('is-free', remaining <= 0);
      this.paintBar();
      this.paintNudge();
      this.valueEl.textContent = remaining <= 0 ? 'FREE (US)' : 'Enter your ZIP';
      this.noteEl.textContent = remaining <= 0
        ? 'Free Economy shipping is unlocked for US addresses. Faster options are shown at checkout.'
        : (document.querySelector('.free-shipping')
          ? 'See what shipping costs before you check out.'
          : 'You’re ' + money(remaining / 100) + ' away from free US shipping. See what shipping costs before you check out.');
    }

    fail(message) {
      this.classList.remove('has-estimate');
      this.classList.add('is-error');
      this.valueEl.textContent = '—';
      this.noteEl.textContent = message;
    }
  }

  customElements.define('spc-ship-estimate', SpcShipEstimate);

  // Place the estimate directly above the Checkout button in the cart drawer and on the cart page.
  var TARGETS = ['form.mini-cart .button-container', '.cart__footer .cart__ctas'];

  function rewordFreeShipping(root) {
    root.querySelectorAll('.free-shipping__text:not(.free-shipping__text--success)').forEach(function (el) {
      if (el.dataset.spcWorded) return;
      var price = el.querySelector('price-money, .price');
      if (!price || !/Spend/i.test(el.textContent)) return;
      el.dataset.spcWorded = '1';
      el.innerHTML = 'You’re ' + price.outerHTML + ' away from free US shipping';
    });
    root.querySelectorAll('.free-shipping__text--success').forEach(function (el) {
      if (/eligible for free shipping/i.test(el.textContent)) el.textContent = 'You’ve unlocked free US shipping.';
    });
  }

  function place() {
    TARGETS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (anchor) {
        var prev = anchor.previousElementSibling;
        if (prev && prev.tagName === 'SPC-SHIP-ESTIMATE') return;
        anchor.parentNode.insertBefore(document.createElement('spc-ship-estimate'), anchor);
      });
    });
    rewordFreeShipping(document);
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    // rAF is throttled to zero in a background tab, so fall back to a timer.
    var run = function () { if (!queued) return; queued = false; place(); };
    requestAnimationFrame(run);
    setTimeout(run, 120);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', place);
  } else {
    place();
  }
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });

  // --- Keep the estimate in step with the cart -------------------------------
  // The drawer re-renders through the Section Rendering API, which leaves this
  // element in place. Without this it keeps the total it read when it first
  // mounted, so the "$X away" figure freezes on the first cart it ever saw.
  var refreshTimer = null;
  function refreshAll() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      document.querySelectorAll('spc-ship-estimate').forEach(function (el) {
        if (typeof el.refresh === 'function') el.refresh(true);
      });
    }, REFRESH_DEBOUNCE);
  }

  // pubsub.js loads before this file, but don't assume it: retry until it is there.
  var subscribed = false;
  function bindPubSub() {
    if (subscribed || typeof subscribe !== 'function') return;
    subscribed = true;
    subscribe('cart-update', refreshAll);     // PUB_SUB_EVENTS.cartUpdate
    subscribe('quantity-update', refreshAll); // PUB_SUB_EVENTS.quantityUpdate
  }
  bindPubSub();
  if (!subscribed) {
    document.addEventListener('DOMContentLoaded', bindPubSub);
    window.addEventListener('load', bindPubSub);
    var tries = 0;
    var poll = setInterval(function () {
      bindPubSub();
      if (subscribed || ++tries > 40) clearInterval(poll);
    }, 250);
  }
  // Belt and braces for anything that changes the cart outside the theme's pubsub
  // (apps, the Shop cart sync, a back/forward restore).
  ['cart:refresh', 'cart:updated', 'shopify:cart:updated'].forEach(function (name) {
    document.addEventListener(name, refreshAll);
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshAll(); });
})();
